let $ = jQuery;

class LandingPageSearch {

  constructor($landingForm) {

    this.$search = $landingForm;
    this.activeClass = "button-hover";
    this.$searchSubmit = $landingForm.find(".form-submit");

    this.bind();
  }

  bind() {
    this.$searchSubmit.off("mouseover.searchLanding").on("mouseover.searchLanding", () => this.activateBtn());
    this.$searchSubmit.off("focus.searchLanding").on("focus.searchLanding", () => this.activateBtn());

    this.$searchSubmit.off("mouseout.searchLanding").on("mouseout.searchLanding", () => this.deactivateBtn());
    this.$searchSubmit.off("blur.searchLanding").on("blur.searchLanding", () => this.deactivateBtn());
  }

  activateBtn() {
    this.$search.addClass(this.activeClass);
  }

  deactivateBtn() {
    this.$search.removeClass(this.activeClass);
  }

}

module.exports = {
  attach: function(context, settings) {
    let $landingSearch = $(".rmd-search-form, .lifecenter-search-form, .homepage-search__form");
        //let $landingForm2 = $(".lifecenter-search-form");

    // $landingForm.add($landingForm2);

    if ($landingSearch.length > 0) {
      let landingSearch = new LandingPageSearch($landingSearch);
    }
  }
};
